import type { FC } from 'react';
import FormattedMessage from '../../../../../../../components/FormattedMessage';
import type { TerminalDisplayState } from '../../../../../../../context/TerminalStore';

interface Props {
  terminalState: TerminalDisplayState;
}

const PaymentButtonStatus: FC<Props> = ({ terminalState }) => {
  if (terminalState === 'BUSY') {
    return (
      <div className="text-small text-yellow-light">
        <FormattedMessage id="checkout.paymentButton.state.inUse" />
      </div>
    );
  }

  if (terminalState === 'OFFLINE') {
    return (
      <div className="text-small font-semibold">
        <FormattedMessage id="checkout.paymentButton.state.unreachable" />
      </div>
    );
  }

  return (
    <p>
      <b>
        <FormattedMessage id="paymentButton.text" />
      </b>
    </p>
  );
};

export default PaymentButtonStatus;
